export enum Voice {
    SALES = 'sales',
    OPERATIONS = 'operations',
    STRATEGY = 'strategy',
}
